import { XClient_ID } from "../../config/config";
import APIError from "../Error/error";
import handleResponseFailure from "../helper/helper";
import { summaryApiProps } from "./summary.types";

/**
 *
 * @param {string}url
 * @returns {Promise}
 */
//reusable api service helper for get requests in the application
//can be used for all GET requests
export const summaryApi = async ({ url }: summaryApiProps) => {
  const jsonData = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      "X-Client-ID": XClient_ID,
    },
    credentials: "include",
    method: "GET",
  });
  if (jsonData.status >= 500) {
    throw new APIError({
      statusCode: Number(jsonData.status),
      apiErrorMessage:
        "Something went wrong please click on reload icon to refresh again if the issue still persists please reach out to VARAHA admin" +
        " requestId " +
        jsonData.headers.get("X-Request-Id"),
      errorCode: undefined,
    });
  }
  const res = await jsonData.json();
  if (jsonData.ok) {
    return res;
  }
  if (!jsonData.ok) {
    const errorResponse: APIError | undefined = handleResponseFailure(
      res,
      jsonData.status,
    );

    throw errorResponse;
  }
};
